import React from "react"

import * as st from './Item.styled.js'

const Item = ({
  name,
  image,
  Icon,
  isActive,
  onHover,
  onClick,
  children,
}) => (
  <st.Wrap isActive={isActive}>
    <st.Content>
      <st.ClickableButton
        isActive={isActive}
        onClick={onClick}
      >
        <Icon />
        {name}
      </st.ClickableButton>
      <st.HoveredButton
        isActive={isActive}
        onMouseEnter={onHover}
      >
        <Icon />
        {name}
      </st.HoveredButton>
      <st.InnerContent>
        <st.InnerScreen
          id={name}
          image={image}
        />
        {children}
      </st.InnerContent>
    </st.Content>
  </st.Wrap>
)

export default Item
